<div class="modal">
  <mat-icon class="close" mat-dialog-close>close</mat-icon>
  <div class="title">
    <mat-icon class="back" (click)="openAfterSales1Modal()"
      >arrow_back_ios</mat-icon
    >{{ data.bus.platform?.name }}
  </div>
  <div class="detail" mat-dialog-content>
    <div class="part">
      您是不是想了解这些
      <span (click)="changePage()"><mat-icon>sync</mat-icon> 换一批</span>
    </div>
    <mat-spinner *ngIf="loading" [diameter]="60"></mat-spinner>
    <div class="part-main">
      <div
        class="item"
        matRipple
        *ngFor="let item of articles"
        [routerLink]="
          '/helping/detail/' +
          item.tag_id +
          '/p/' +
          page +
          '/article/' +
          item.id
        "
      >
        {{ item.title }}
      </div>
    </div>
    <ng-container *ngIf="!flag">
      <div
        class="part"
        style="text-decoration-line: underline; cursor: pointer"
        (click)="flag = true"
      >
        需要进一步帮助
      </div>
    </ng-container>
    <ng-container *ngIf="flag">
      <div class="part" style="text-decoration-line: underline">
        针对您的订单，我们建议您
      </div>
      <div class="part-main flex">
        <div class="item" matRipple [routerLink]="'/helping'">帮助中心</div>
        <div class="item" matRipple (click)="openWorkorder()">
          提交工单人工处理
        </div>
      </div>
    </ng-container>
  </div>
</div>
